import { Attachment } from "airtable"
import ReactMarkdown from "react-markdown"
import tw from "twin.macro"
import Image from "next/image"
import { ContentDataProps } from "../../pages/[parent]"
import { StyledBodyText } from "../bodyText"
import Zoom from "react-medium-image-zoom"

interface ExhibitionImageProps {
  image_url: string
  image_preview: Array<Attachment>
  caption: string
}
export const ExhibitionImage = ({ image_url, image_preview, caption }: ExhibitionImageProps) => {
  const thisImage = image_preview[0].thumbnails && image_preview[0].thumbnails.large
  const width = thisImage && thisImage.width
  const height = thisImage && thisImage.height

  const altText = caption ? `${caption} – The Richard Pousette-Dart Foundation` : `The Richard Pousette-Dart Foundation`

  return (
    <div tw="py-6 flex flex-col font-sans space-y-4 tablet-lg:(flex-row space-x-4 space-y-0)">
      <div tw="max-w-[475px] flex-grow-0">
        <Zoom
          zoomImg={{
            alt: altText,
            src: image_url,
            srcSet: image_url,
          }}
        >
          <Image src={image_url} width={width} height={height} alt={altText} sizes="(max-width: 768px) 100vw, 33vw" />
        </Zoom>
      </div>
      <div className="caption" tw="max-w-[475px]">
        <ReactMarkdown>{caption}</ReactMarkdown>
      </div>
    </div>
  )
}

interface CardProps {
  body: string
  year: string
  image_url: string
  image_preview: Array<Attachment>
  caption: string
}

const Card = (props: CardProps) => {
  const { body, year, image_url, image_preview, caption } = props
  const bodyText = body ? body.toString() : ""
  const captionText = caption ? caption.toString() : ""

  return (
    <div tw="">
      {image_url && (
        <ExhibitionImage image_url={image_url.toString()} image_preview={image_preview} caption={captionText} />
      )}
      <h3 tw="text-2xl">{year && year.toString()}</h3>
      <StyledBodyText>
        <ReactMarkdown>{bodyText}</ReactMarkdown>
      </StyledBodyText>
    </div>
  )
}

const Exhibitions = (props: ContentDataProps) => {
  const { contentData } = props

  return (
    <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
      <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 desktop:(gap-6)">
        <div tw="col-span-4 tablet-lg:col-span-8">
          <div tw="space-y-8 tablet-lg:(space-y-12)">
            {contentData.map((item: any, i: number) => {
              return <Card {...item.fields} key={i} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Exhibitions
